import { useMemo } from "react";
import PropTypes from 'prop-types';
import { parseSummaryContent, formatTitle, formatObjectValue, isEmptyValue, shouldRemoveKey } from "./summaryUtils";

const SummaryTab = ({ summary, localisedValues }) => {

    const response = useMemo(() => {
        return parseSummaryContent(summary);
    }, [summary]);

    const renderValue = (value) => {
        if (Array.isArray(value)) {
            return (
                <ul className="list-point padding-top-0">
                    {value.map((item, index) => (
                        <li key={index}>
                            {typeof item === "object"
                                ? formatObjectValue(item)
                                : item}
                        </li>
                    ))}
                </ul>
            );
        }

        if (typeof value === "object" && value !== null) {
            return <p>{formatObjectValue(value)}</p>;
        }

        return <p>{value}</p>;
    };

    const renderedSummary = useMemo(() => {
        if (!response || Object.keys(response).length === 0) {
            return (
                <div className="no-session-summary">
                    <h3>{localisedValues?.no_summary_available}</h3>
                </div>
            );
        }

        return Object.entries(response)?.map(([key, value]) => {
            if (shouldRemoveKey(key) || isEmptyValue(value)) return null;

            return (
                <div className="summary-info-box" key={key}>
                    <div className="info-title">{formatTitle(key)}</div>
                    <div className="info-desc">{renderValue(value)}</div>
                </div>
            );
        });
    }, [response, localisedValues]);

    return <div className="session-summary">{renderedSummary}</div>;
};

SummaryTab.propTypes = {
    summary: PropTypes.any,
    localisedValues: PropTypes.object,
};

export default SummaryTab;
